import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartOptions
} from 'chart.js';

// Registrar componentes necessários do Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const TrafficChart = () => {
  const data = {
    labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    datasets: [
      {
        label: 'Visitas',
        data: [1200, 1900, 3000, 5000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000],
        borderColor: 'rgb(79, 70, 229)',
        backgroundColor: 'rgba(79, 70, 229, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        border: {
          display: false
        },
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: false,
        },
        ticks: {
          callback: (value: string | number) => {
            const numValue = Number(value);
            if (isNaN(numValue)) return value.toString();
            if (numValue >= 1000) {
              return `${numValue / 1000}k`;
            }
            return numValue.toString();
          },
        },
      },
      x: {
        border: {
          display: false
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Tráfego do Site</h2>
        <div className="flex space-x-2">
          <button className="rounded-md bg-indigo-100 px-3 py-1 text-sm font-medium text-indigo-700">
            30 dias
          </button>
          <button className="rounded-md px-3 py-1 text-sm font-medium text-gray-500 hover:bg-gray-100">
            90 dias
          </button>
          <button className="rounded-md px-3 py-1 text-sm font-medium text-gray-500 hover:bg-gray-100">
            1 ano
          </button>
        </div>
      </div>
      <div className="mt-4 h-80">
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default TrafficChart;
